const Stop = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (

        <svg
            height={`${size}px`}
            width="18" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 2V0h6v2zm3 19a8.65 8.65 0 0 1-3.487-.712A9.2 9.2 0 0 1 2.65 18.35a9.2 9.2 0 0 1-1.937-2.863A8.65 8.65 0 0 1 0 12q0-1.85.713-3.488A9.2 9.2 0 0 1 2.65 5.65a9.2 9.2 0 0 1 2.863-1.938A8.65 8.65 0 0 1 9 3a8.9 8.9 0 0 1 2.975.5Q13.4 4 14.65 4.95l1.4-1.4 1.4 1.4-1.4 1.4a9.7 9.7 0 0 1 1.45 2.675Q18 10.45 18 12a8.65 8.65 0 0 1-.712 3.488 9.2 9.2 0 0 1-1.938 2.862 9.2 9.2 0 0 1-2.862 1.938A8.65 8.65 0 0 1 9 21m0-2q2.9 0 4.95-2.05T16 12t-2.05-4.95T9 5 4.05 7.05 2 12t2.05 4.95T9 19m-3-4V9.025zm0 0h6V9.025H6z" fill={color} /></svg>
    )
}

export default Stop;